import { createOutlineIcon } from "../createIcon";

export const ChevronRightOutlineIcon = createOutlineIcon(
  <>
    <path d="m10 7 5 5-5 5" />
  </>,
  "ChevronRightOutlineIcon"
);
